import React, {useCallback, useMemo} from 'react';
import {Modal} from 'antd';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import ModelShareSideBarModal from './ModelShareSideBarModal';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {tid} from '../../../../../testUtils';
import {MODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {ModelActionProps} from '../../../actionMenuTypes';
import {ShareAltOutlined} from '@ant-design/icons';

const ModelShareSideBarModalMenuButton: React.FC<Partial<ModelActionProps>> = ({model, onSuccess}) => {
  const {buttonRef, openModal, closeModal} = useSideBarModal(model?.uuid);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model && (
        <Modal
          open={!!buttonRef}
          onCancel={closeModal}
          footer={null}
          title={null}
          width={480}
          centered
          closable={false}
          maskClosable={false}
          destroyOnHidden
          styles={{
            content: {
              padding: '34px',
            },
          }}
        >
          {!!buttonRef && <ModelShareSideBarModal model={model} onSuccess={handleSuccess} onCancel={closeModal} />}
        </Modal>
      )
    );
  }, [buttonRef, closeModal, handleSuccess, model]);

  return (
    <>
      <SideBarButtonItem
        {...tid(MODEL_ACTION_MENU_IDS.SHARE)}
        disabled={!model}
        onClick={openModal}
        icon={<ShareAltOutlined />}
        text="Share Model Entry"
      />
      {ModalComponent}
    </>
  );
};

export default ModelShareSideBarModalMenuButton;
